import { extensionFromName } from './attachmentMetaExtension.js'

export function formatBytes(bytes) {
  if (typeof bytes !== 'number' || Number.isNaN(bytes) || bytes <= 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  const value = bytes / k ** i
  const rounded = i === 0 ? value : value >= 10 || value % 1 === 0 ? Math.round(value) : value.toFixed(1)
  return `${rounded} ${sizes[i]}`
}

export function fileTypeLabel(file) {
  if (!file || typeof file !== 'object') return 'file'
  const fileName = typeof file.name === 'string' ? file.name : ''
  const mimeType = typeof file.type === 'string' ? file.type : ''
  const ext = extensionFromName(fileName)
  if (ext) return ext
  if (mimeType && mimeType !== 'application/octet-stream') {
    const part = mimeType.split('/')[1]
    return part ? part.slice(0, 12) : 'file'
  }
  return 'file'
}
